import { useCallback } from 'react';

import { cx } from '@libs/classnames';
import { DateInput } from '@ui/components/DateInput';

import styles from './DateRangeInput.module.css';

type Props = {
  preset?: 'default' | 'heavy';
  className?: string;
  value?: {
    start?: Date | number | null;
    end?: Date | number | null;
  };
  onChange: (value: { start: Date | null; end: Date | null }) => void;
};
export function DateRangeInput({ preset, className, value, onChange }: Props) {
  const onStartChange = useCallback(
    (newValue: Date | null) => {
      let end = value?.end ? new Date(value.end) : null;
      if (end && newValue && end < newValue) {
        end = newValue;
      }

      onChange({
        start: newValue,
        end,
      });
    },
    [value, onChange],
  );
  const onEndChange = useCallback(
    (newValue: Date | null) => {
      let start = value?.start ? new Date(value.start) : null;
      if (start && newValue && start > newValue) {
        start = newValue;
      }

      onChange({
        start: start,
        end: newValue,
      });
    },
    [value, onChange],
  );

  return (
    <div className={cx(styles.dateRangeInput, className)}>
      <DateInput
        preset={preset}
        prefix="с "
        className={styles.startInput}
        value={value?.start}
        onChange={onStartChange}
      />
      <DateInput
        preset={preset}
        prefix="по "
        alignRight
        className={styles.endInput}
        value={value?.end}
        onChange={onEndChange}
      />
    </div>
  );
}
